<template>
  <div
    v-if="!resultSizes.no_result && (isAvailable === true || storeId !== '33')"
    class="result-container"
  >
    <Title :title="i18n['title']" :level="3" class="resultTitle" />
    <div class="size-box">
      <p v-if="resultSizes.shoes_size.length > 1">
        {{ resultSizes.shoes_size[0] }}-{{ resultSizes.shoes_size[1] }}
        {{ resultSizes.size_type }}
      </p>
      <p v-else>
        {{ resultSizes.shoes_size[0] }} {{ resultSizes.size_type }}
        <!-- this product is available{{ isAvailable }} -->
      </p>
    </div>
    <div v-if="storeId !== '33'" style="width: 100%">
      <ButtonSubmit
        :text="i18n['addtocart']"
        class-name="validateButtonSubmitWhite"
        @submitButton="
          AddtoCartManfield(resultSizes.shoes_size[0], resultSizes.size_type)
        "
      />
    </div>
    <div v-else style="width: 100%">
      <ButtonSubmit
        :text="i18n['addtocart']"
        class-name="validateButtonSubmitWhite"
        @submitButton="triggerSelectSizeByDataBind(resultSizes.shoes_size[0])"
      />
    </div>
  </div>
  <div
    v-else-if="isAvailable === false && resultSizes.shoes_size[0] !== undefined"
    class="result-container"
  >
    <Title :title="i18n['title']" :level="3" class="resultTitle" />
    <div class="size-box">
      <p v-if="resultSizes.shoes_size.length > 1">
        {{ resultSizes.shoes_size[0] }}-{{ resultSizes.shoes_size[1] }}
        {{ resultSizes.size_type }}
      </p>
      <p v-else>
        {{ resultSizes.shoes_size[0] }} {{ resultSizes.size_type }}
        <!-- this product is available{{ isAvailable }} -->
      </p>
    </div>
    <Title
      :title="'This size is currently unavailable'"
      :level="7"
      class="resultTitle"
      style="margin-top: 26px"
    />
    <ButtonSubmit
      :text="i18n['Alert']"
      class-name="validateButtonSubmitWhite"
      @submitButton="TriggerAlert()"
    />
  </div>
  <div
    v-else-if="resultSizes.shoes_size[0] === undefined"
    class="result-container"
  >
    <Title
      :title="'This size does not exist for this model'"
      :level="3"
      class="resultTitle"
    />
    <ButtonSubmit
      :text="i18n['button']"
      class-name="validateButtonSubmitWhite"
      @submitButton="$emit('reset-submit-button')"
    />
  </div>
  <div v-else class="result-container">
    <Title :title="i18n['title_no_product']" :level="3" class="resultTitle" />
    <ButtonSubmit
      :text="i18n['button']"
      class-name="validateButtonSubmitWhite"
      @submitButton="$emit('reset-submit-button')"
    />
  </div>
</template>

<script>
import Title from "@/components/modal/ui/Title.vue";
import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";
import { customLogger } from "../../../utils";

export default {
  name: "ResultSizeReco",
  components: {
    Title,
    ButtonSubmit,
  },
  props: {
    i18n: {
      type: Object,
      default: () => ({}),
    },
    resultSizes: {
      type: Object,
      default: () => [],
    },
    isAvailable: {
      type: Boolean,
      default: false,
    },
    storeId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      size: "42 FR",
    };
  },
  methods: {
    TriggerAlert() {
      const externalButton = document.querySelector(".link-arrow");
      if (externalButton) {
        externalButton.click();
        this.$emit("closemodal");
      } else {
        customLogger('External button not found');
      }
    },
    async triggerChangeEvent(element) {
      // Function to trigger the change event
      return new Promise((resolve) => {
        var event = new Event("change", {
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(event);
        resolve();
      });
    },
    async AddtoCartManfield(size, sizetype) {
      if (sizetype === "UK") {
        sizetype = "default";
      } else if (sizetype === "US") {
        sizetype = "US M";
      }

      // Select the size system dropdown and set it to 'FR'
      var sizeSystemSelect = document.querySelector("#sizeSystemSelect");
      if (!sizeSystemSelect) {
        customLogger("Size system select not found for #sizeSystemSelect");
        return;
      }
      sizeSystemSelect.value = sizetype;

      await this.triggerChangeEvent(sizeSystemSelect).then(() => {
        //#region add to cart
        // Now find and click the button with the text '43 FR'
        var sizeButtons = document.querySelectorAll(
          "ul.form-control-size li button"
        );
        for (var i = 0; i < sizeButtons.length; i++) {
          var button = sizeButtons[i];
          var buttonText = button.textContent || button.innerText; // Get the text inside the button

          if (sizetype === "default") {
            sizetype = "UK";
          } else if (sizetype === "US M") {
            sizetype = "US";
          }

          if (buttonText.trim() === `${size} ${sizetype}`) {
            button.click();
            // Click the button with the text '43 FR'
            break; // Exit the loop after clicking
          }
        }
        //#endregion
      }).then(() => {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            const addtocart = document.querySelector(
              "button[data-ng-click='addShippingCategoriesProduct()']"
            )
            customLogger('check for add to cart button')
            if (addtocart) {
              customLogger('add to cart button found')
              addtocart.click();
              this.$emit("closemodal");
              clearInterval(interval);
              resolve();
            }
          }, 1000);
        });
      }).then(() => {
          if (window.matomoTracker) {
            customLogger("add to cart modal");
            matomoTracker.trackGoal(9);
            matomoTracker.trackEvent("Site", "Add to cart modal v3");
          }
      }).catch((error) => {
        customLogger('add to cart MF', error);
      })
    },
    triggerSelectSizeByDataBind(size) {
      //FIXME: size must be protected use try catch
      size = size.toString().replace('.', ',')
      // Get all the <li> elements within the .product-size-box
      var listItems = document.querySelectorAll(".product-size-box li");
      var addtocart = document.querySelector("#btn-addtocart");

      // Iterate through the list items
      for (var i = 0; i < listItems.length; i++) {
        var item = listItems[i];
        // Check if the data-bind attribute contains the 'selectSize' call with the correct size
        if (
          item.getAttribute("data-bind") &&
          item.getAttribute("data-bind").includes(`selectSize('${size}',`)
        ) {
          // If it's not disabled, click it
          if (!item.getAttribute("disabled")) {
            item.click();
            addtocart.click();
            if (window.matomoTracker) {
              customLogger("add to cart modal");
              matomoTracker.trackGoal(9);
              matomoTracker.trackEvent("Site", "Add to cart modal v3");
        }
            this.$emit("closemodal");
            return true; // Click was successful
          }
        }
      }
      return false; // No matching element was clickable
    },
  },
};
</script>

<style scoped>
.result-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  margin: auto !important;
}

.resultTitle {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.size-box {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  padding: 20px !important;
  border: 1px solid black !important;
  background-color: white !important;
}

.size-box p {
  font-size: 24px !important;
  margin: 0 !important;
}
</style>
